const SubtleWrapper = ({ title, subtitle, children }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      {title && (
        <h2 className="text-sm font-semibold text-gray-700 mb-2 font-poppins">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="text-xs text-text-secondary mb-4">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};
export default SubtleWrapper;
